




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CartHeader extends Vue {
  @Prop({ required: true }) private isExpanded!: boolean;

  @Prop({ default: false }) private showMore!: boolean;

  @Prop({ default: false }) private showClear!: boolean;
}
